export enum UploadStatus {
  Pending = "Pending",
  FileSelected = "FileSelected",
  Success = "Success",
  Loading = "Loading",
  Error = "Error",
}
